// import React from "react";
// import PropTypes from "prop-types";
// import MDInput from "components/MDInput";
// import { InputAdornment } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// function ADSearch({ searchQuery, setSearchQuery, placeholder }) {
//   return (
//     <MDInput
//       type="text"
//       fullWidth
//       value={searchQuery}
//       onChange={(e) => setSearchQuery(e.target.value)}
//     //   placeholder={placeholder || "Search..."}
//       label={placeholder || "Search..."}
//       sx={{
//         minWidth: "200px",
//         maxWidth: "450px",
//         ml: "3px",
//       }}
//     //   InputProps={{
//     //     startAdornment: (
//     //       <InputAdornment position="start">
//     //         <SearchIcon color="action" />
//     //       </InputAdornment>
//     //     ),
//     //   }}
//     />
//   );
// }

// ADSearch.propTypes = {
//   searchQuery: PropTypes.string.isRequired,
//   setSearchQuery: PropTypes.func.isRequired,
//   placeholder: PropTypes.string,
// };

// export default ADSearch;


// ######################################################

import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";

function ADSearch({ searchQuery, setSearchQuery, placeholder }) {
  return (
    // <MDInput
    //   type="text"
    //   fullWidth
    //   value={searchQuery}
    //   onChange={(e) => setSearchQuery(e.target.value)}
    //   label={placeholder || "Search..."}
    //   sx={{
    //     minWidth: "200px",
    //     maxWidth: "450px",
    //     ml: "3px",
    //   }}
    // />


     <MDBox>
          {/* 🟣 Title */}
          <MDTypography
            variant="button"
            fontWeight="medium"
            color="text"
            sx={{
              marginBottom: 1,
              display: "block",
              textAlign: "center",
            }}
          >
            Search
          </MDTypography>
    
          {/* 🩶 Grey background container */}
          <MDBox
            sx={{
              borderRadius: "16px",
              backgroundColor: "#f0f2f5",
              padding: "14px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDInput
              type="text"
              placeholder={placeholder || "Search..."}
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                minWidth: "340px",
                maxWidth: "420px",
                "& .MuiInputBase-root": {
                  borderRadius: "12px",
                  backgroundColor: "white !important",
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                  paddingLeft: "6px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </MDBox>
        </MDBox>
  );
}

ADSearch.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default ADSearch;
